import { action, Action } from 'typesafe-actions'

import {
  ContratacaoTypes,
  ContratacaoRequestPayload,
  ContratacaoSuccessAction,
  ContratacaoErrorAction,
} from './types'

export const contratacaoRequest = (payload: ContratacaoRequestPayload): Action =>
  action(ContratacaoTypes.CONTRATACAO_REQUEST, payload)

export const contratacaoSuccess = (): ContratacaoSuccessAction =>
  action(ContratacaoTypes.CONTRATACAO_SUCCESS)

export const contratacaoError = (): ContratacaoErrorAction =>
  action(ContratacaoTypes.CONTRATACAO_ERROR)
